import { render, staticRenderFns } from "./BusinessStat.vue?vue&type=template&id=6f752756&scoped=true"
import script from "./BusinessStat.vue?vue&type=script&lang=js"
export * from "./BusinessStat.vue?vue&type=script&lang=js"
import style0 from "./BusinessStat.vue?vue&type=style&index=0&id=6f752756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f752756",
  null
  
)

export default component.exports